import { NgModule, APP_INITIALIZER } from '@angular/core';
import { LocalizationPipe } from './pipes/localization.pipe';
import { LocalizationListPipe } from './pipes/localization-list.pipe';
import { LocalizationService } from './services/localization.service';
import { LocalizationFromParamsPipe } from './pipes/localization-from-params.pipe';
import { LOCALIZATION_RESOURCE } from './tokens/localization.token';
import { LanguageTagEnum } from './enums/language-tag.enum';
import { LanguageResourceLoader }  from './types/language-resource-loader.type';
@NgModule({
    declarations: [
        LocalizationPipe,
        LocalizationListPipe,
        LocalizationFromParamsPipe
    ],
    imports: [
    ],
    exports: [
        LocalizationPipe,
        LocalizationListPipe,
        LocalizationFromParamsPipe
    ],
    providers: [
        {
            provide: LOCALIZATION_RESOURCE,
            useValue: {
                [LanguageTagEnum.en_GB]: () => import('./localization.en.model'),
                [LanguageTagEnum.en_US]: () => import('./localization.en.model'),
                [LanguageTagEnum.fr_CA]: () => import('./localization.fr-CA.model'),
                [LanguageTagEnum.fr_FR]: () => import('./localization.fr-FR.model'),
            }
        },
        {
            // May be considered legacy in newer Angular standalone architecture.
            // If we move away from NgModules, initialization should be handled via provideAppInitializer.
            provide: APP_INITIALIZER,
            useFactory: (service: LocalizationService | LanguageResourceLoader) => {
                // Some sub-projects don’t extend LocalizationService
                return () => service?.initLocalization?.() ?? Promise.resolve();
            },
            deps: [LocalizationService],
            multi: true
        }
    ]
})
export class LocalizationModule {
}
